// The cross-field rule shared by the orchestrator consumers' handleFilters: an
// amount filter is valid only when its value and its operator are both set or both
// unset. Returns the filters unchanged when every field is paired, or false when
// any pair is half-filled (the orchestrator reads false as "reject this change").
// Boolean(value) !== Boolean(operator) is exactly the consumers' inline
// (value && !operator) || (!value && operator) check.
export const validatePairedAmountFilters =
  (amountFields: string[]) =>
  <T>(filters: T): T | false => {
    const values = filters as Record<string, unknown>;
    const hasHalfFilledPair = amountFields.some(
      field => Boolean(values[field]) !== Boolean(values[`${field}_operator`]),
    );
    return hasHalfFilledPair ? false : filters;
  };
